import { getTimeFromTimeStamp } from "../../../../util/time-helpers";

export const durationValues = [
  { id: 1, name: "Days" },
  { id: 7, name: "Weeks" },
  { id: 30, name: "Months" },
  { id: 365, name: "Years" },
];

export const reminderValues = [
  { id: "2", name: "Before Due Date" },
  { id: "3", name: "After Start Date" },
];

export const reminderRecurringValues = [
  { id: "1", name: "Daily" },
  { id: "2", name: "Weekly" },
  { id: "3", name: "Monthly" },
  { id: "5", name: "Hourly" },
  { id: "6", name: "Custom" },
];

export const reminderRecurringIntervalTypeValues = [
  { id: "1", name: "Days" },
  { id: "2", name: "Weeks" },
  { id: "3", name: "Months" },
  { id: "4", name: "Years" },
];

export const allReminderValues = [
  { id: "0", name: "On End Date" },
  { id: "1", name: "Recurring" },
  { id: "2", name: "Before Due Date" },
  { id: "3", name: "After Start Date" },
];

export const ReminderEnum = Object.freeze({
  OnEndDate: "0",
  Recurring: "1",
  BeforeDueDate: "2",
  AfterStartDate: "3",
});

export const PrepareModifyReminder = (templateData) => {
  switch (templateData?.Reminder?.id) {
    case ReminderEnum.OnEndDate:
      return {
        ReminderOnDueDate: true,
        ReminderOneTime: false,
        ReminderOneTimeTime: getTimeFromTimeStamp(
          templateData?.ReminderOneTimeTime
        ),
        ReminderRecurring: "",
        ReminderRecurringTime: null,
        ReminderRecurringIntervalType: "",
        ReminderRecurringIntervalValue: 0,
        ReminderOneTimeDaysBefore: 0,
      };

    case ReminderEnum.Recurring:
      return {
        ReminderOnDueDate: false,
        ReminderOneTime: false,
        ReminderRecurring: templateData?.ReminderRecurring,
        ReminderRecurringTime: getTimeFromTimeStamp(
          templateData?.ReminderRecurringTime
        ),
        ...(templateData?.ReminderRecurring === "Custom" && {
          ReminderRecurringIntervalType:
            templateData?.ReminderRecurringIntervalType,
          ReminderRecurringIntervalValue:
            templateData?.ReminderRecurringIntervalValue,
        }),
        ReminderOneTimeTime: null,
        ReminderOneTimeDaysBefore: 0,
      };

    case ReminderEnum.BeforeDueDate:
    case ReminderEnum.AfterStartDate:
      return {
        ReminderOnDueDate: false,
        ReminderOneTime: true,
        ReminderOneTimeDaysBefore: templateData?.ReminderOneTimeDaysBefore,
        ReminderOneTimeTime: getTimeFromTimeStamp(
          templateData?.ReminderOneTimeTime
        ),
        ReminderRecurring: "",
        ReminderRecurringTime: null,
        ReminderRecurringIntervalType: "",
        ReminderRecurringIntervalValue: 0,
      };

    default:
      return {
        Reminder: "",
        ReminderOnDueDate: false,
        ReminderOneTime: false,
        ReminderOneTimeTime: null,
        ReminderRecurring: "",
        ReminderRecurringTime: null,
        ReminderRecurringIntervalType: "",
        ReminderRecurringIntervalValue: 0,
        ReminderOneTimeDaysBefore: 0,
      };
  }
};

export const PrepareModifyTemplate = (template, isCreate) => {
  let templateRequest = {
    ...PrepareModifyReminder(template),
    ProjectType: template.ProjectType,
    Description: template.Description,
    IsVisible: template.IsVisible,
    Reminder: template?.Reminder?.name,
    Days: Math.round(template.Days) * template?.DefaultDurationType.id,
    Id: template.Id,
    IsCreateNewUserTasks: template.IsCreateNewUserTasks,
    IsCreateNewUserTasksCurrent: template.IsCreateNewUserTasksCurrent,
    CompanyId: template.CompanyId,
    Owners: template.Owners,
    Members: template.Members,
    IsMultiOwner: template.IsMultiOwner,
    CanTransferOwner: template.CanTransferOwner,
  };
  if (!isCreate) {
    templateRequest.CreatorUserId = template.CreatorUserId;
  }
  return templateRequest;
};

export const GetDurationFromInterval = (interval) => {
  let DefaultDurationInterval, Day;

  durationValues.forEach((value) => {
    if (interval % value.id === 0) {
      DefaultDurationInterval = value;
      Day = interval / value.id;
    }
  });

  return { Day, DefaultDurationInterval };
};

export const InitializeForm = (templateData, isEdit, isLoading) => {
  if ((templateData.Id > 0 && !isLoading) || !isEdit) {
    // for create and edit
    let result = {
      ...templateData,
      DefaultDurationType: durationValues[0],
      ReminderOneTime: true,

      Reminder: null,
      ReminderOneTimeTime: new Date().setHours(9, 30),
      ReminderOneTimeDaysBefore: 2,

      ReminderRecurring: reminderRecurringValues[0].name,
      ReminderRecurringTime: new Date().setHours(9, 30),
      ReminderRecurringIntervalType:
        reminderRecurringIntervalTypeValues[0].name,
      ReminderRecurringIntervalValue: 2,
    };

    const { Day, DefaultDurationInterval } = GetDurationFromInterval(
      templateData?.Days
    );
    result.DefaultDurationType = DefaultDurationInterval;
    result.Days = Day;

    if (isEdit && templateData?.Reminder) {
      result.Reminder = allReminderValues.find(
        (value) => value.name === templateData.Reminder
      );

      if (result.Reminder.id === ReminderEnum.OnEndDate) {
        result.ReminderOneTimeTime = new Date(templateData.ReminderOneTimeTime);
      } else if (
        result.Reminder.id === ReminderEnum.BeforeDueDate ||
        result.Reminder.id === ReminderEnum.AfterStartDate
      ) {
        result.ReminderOneTimeDaysBefore =
          templateData.ReminderOneTimeDaysBefore;
        result.ReminderOneTimeTime = new Date(templateData.ReminderOneTimeTime);
      } else if (result.Reminder.id === ReminderEnum.Recurring) {
        result.ReminderRecurring = reminderRecurringValues.find(
          (value) => value.name === templateData.ReminderRecurring
        ).name;
        result.ReminderRecurringTime = new Date(
          templateData.ReminderRecurringTime
        );

        if (result.ReminderRecurring === "Custom") {
          result.ReminderRecurringIntervalType =
            reminderRecurringIntervalTypeValues.find(
              (value) =>
                value.name === templateData.ReminderRecurringIntervalType
            ).name;
          result.ReminderRecurringIntervalValue =
            templateData.ReminderRecurringIntervalValue;
        }
      }
    }

    return result;
  }
};

export const isDynamicFieldsInvalid = (dynamicFields, checked, isSubmitting) => {
  let result = dynamicFields.some((field) => {
    if (field.Label.length < 1) {
      return true;
    }
    if (field.Lookup) {
      if (!(!!field.LookupValues[0] && !!field.LookupValues[1])) {
        return true;
      }
    }
    return false;
  });

  return result || checked || isSubmitting;
};
